import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Container } from '@fiverr-private/layout_components';
import AiSuggestionRow from '../AiSuggestionRow';
import QuickFilters from '../QuickFilters';

const AiPillTypingState = ({ historyIds, gigIds }) => {
    const hasRows = !!historyIds.length || !!gigIds.length;
    // Only the first rows shown are revealed; rows swapped in while typing appear without animation.
    const hasRevealedRef = useRef(false);
    const shouldReveal = !hasRevealedRef.current;

    useEffect(() => {
        if (hasRows) {
            hasRevealedRef.current = true;
        }
    });

    if (!hasRows) {
        return null;
    }

    return (
        <>
            <Container as="ul" display="flex" flexDirection="column" gap="1">
                {historyIds.map((id, index) => (
                    <AiSuggestionRow key={id} id={id} index={index} isHistory shouldReveal={shouldReveal} />
                ))}
                {gigIds.map((id, index) => (
                    <AiSuggestionRow key={id} id={id} index={historyIds.length + index} shouldReveal={shouldReveal} />
                ))}
            </Container>
            <QuickFilters />
        </>
    );
};

AiPillTypingState.propTypes = {
    historyIds: PropTypes.arrayOf(PropTypes.string),
    gigIds: PropTypes.arrayOf(PropTypes.string),
};

AiPillTypingState.defaultProps = {
    historyIds: [],
    gigIds: [],
};

export { AiPillTypingState };
export default AiPillTypingState;
